/**
 *
 * Main application component.
 *
 * User Interface component hierarchy is managed from this component.
 *
 */
import React from 'react';
import {UserCheck} from 'shared/UserCheck';
import {ManufacturerCheck} from 'shared/ManufacturerCheck';
import {UserMessages} from 'shared/UserMessages';
import {Messages} from 'shared/components/Header/Messages';
import {useNumberInputScrollDisabler} from 'shared/NumberInputScrollDisabler';
import ErrorBoundary from 'shared/ErrorBoundary';
import {ContextManager} from 'contexts';
import {Toaster} from 'react-hot-toast';
import {urlPartsJob} from 'shared/helpers';
import {Updates} from 'shared/components/Updates';
import {Outlet, useSearchParams} from 'react-router-dom';
import {Surveys} from 'shared/components/Surveys';

export const App = () => {
    const data = urlPartsJob();
    const [searchParams] = useSearchParams();

    const narrowHeader =
        searchParams.has('narrow-header') &&
        searchParams.get('narrow-header') == '1';

    useNumberInputScrollDisabler();

    return (
        <ContextManager>
            <ManufacturerCheck>
                <UserCheck>
                    <Surveys />
                    <Updates />
                    <Toaster
                        containerStyle={{
                            bottom: '30px',
                            right: '30px',
                        }}
                    />
                    <UserMessages />
                    <Messages />
                    <section
                        className={
                            data.length && !narrowHeader
                                ? 'job-page mainContainer'
                                : narrowHeader
                                  ? 'narrow-header mainContainer'
                                  : 'mainContainer'
                        }>
                        <ErrorBoundary>
                            <Outlet />
                        </ErrorBoundary>
                    </section>
                </UserCheck>
            </ManufacturerCheck>
        </ContextManager>
    );
};
